import React from "react";
import { Form } from "semantic-ui-react";
import HeaderWidget from "../Widgets/HeaderWidget";

const NullField = (props: any) => {
    return (
        <Form.Field>
            <HeaderWidget {...props} />
        </Form.Field>
    );
};

export default NullField;